<script lang="ts">
  import WaitButton from "../../components/WaitButton.svelte";
  import { collectDeviceData } from "../../lib/kountConsent";

  let {
    back,
    inactive,
    kountSessionId,
  }: {
    back: () => void;
    inactive: boolean;
    kountSessionId: string;
  } = $props();

  const handleClick = async (event: MouseEvent) => {
    const kountSuccess = await collectDeviceData(kountSessionId);
    if (!kountSuccess) {
      return alert(
        "Fraud prevention check failed. You may need to disable privacy controls in your browser to continue.",
      );
    }
    (event.target as HTMLElement).closest("form")?.requestSubmit();
  };
</script>

<input type="hidden" name="kount_session_id" value={kountSessionId} />

<div class="h-full">
  <p>
    JLG will conduct a soft credit check executed by JLG’s vendor, Checkboard Limited, whose Terms & Conditions are
    available
    <a
      href="https://checkboard.com/terms-and-conditions"
      target="_blank"
      rel="noopener"
      class="text-blue-600 hover:underline">here</a
    >. This search has NO impact on your credit rating. As part of this process, device information (such as your IP
    address and browser details) will be collected by Kount, an Equifax company, for fraud prevention purposes in
    accordance with
    <a
      href="https://kount.com/legal/privacy-policy"
      target="_blank"
      rel="noopener"
      class="text-blue-600 hover:underline">Kount's Privacy Policy</a
    >.
  </p>
  <p>
    By clicking "Find my agreements", you consent to JLG sending a Letter of Complaint to the lenders to determine if
    your PCP or HP agreements were mis-sold and to present your claim for each agreement found via the credit check.
  </p>
  <p>
    You will have a fourteen-day cooling off period under the terms of JLG's retainer for each new matter opened via
    this credit check.
  </p>
</div>

<div class="floating-footer">
  <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  <WaitButton type="button" class="btn btn-primary" disabled={inactive} onclick={handleClick}>
    Find my agreements
  </WaitButton>
</div>
